import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98dc4c4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id", "disabled"]
const _hoisted_3 = { class: "textareaBox__label" }
const _hoisted_4 = {
  key: 0,
  class: "inputBox__error"
}

import { computed, getCurrentInstance, onMounted, ref } from 'vue';
import { StylesType } from '@/types';
import { ComponentInternalInstance } from '@vue/runtime-core';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTextarea',
  props: /*#__PURE__*/_mergeModels({
    label: {},
    styleType: { default: undefined },
    styles: {},
    height: { default: '36' },
    maxHeight: {},
    error: {},
    withScroll: { type: Boolean },
    disabled: { type: Boolean },
    isEditInModal: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['focus', 'blur'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const inputValue = _useModel<string | undefined>(__props, "modelValue");

const props = __props;
const emit = __emit;

const instance: ComponentInternalInstance | null = getCurrentInstance();
const uuid = ref(instance?.uid);

const listeners = computed(() => ({
  focus: (e: PointerEvent) => emit('focus', e),
  blur: (e: PointerEvent) => emit('blur', e),
}));
const errorMessage = ref('');
const isError = ref(false);

const cssProps = computed(() => {
  let styles: { [key: string]: string | undefined } = {
    '--border': props.styles?.border ?? '1px solid #a79f9a',
    '--background-color': props.styles?.backgroundColor,
  };

  if (props.maxHeight) {
    styles = {
      ...styles,
      '--max-height': `${props.maxHeight}px`,
    };
  }

  return styles;
});

const heightConst = ref({
  '--min-height': `${props.height}px`,
});
const resize = () => {
  let textarea: HTMLInputElement | null = document.querySelector(
    `#textarea${uuid.value}`,
  );
  let textareaBox: HTMLInputElement | null = document.querySelector(
    `#textareaBox${uuid.value}`,
  );

  if (textarea) {
    textarea.style.height = 'auto';
    textarea.style.height =
      textarea.scrollHeight < +props.height
        ? +props.height + 'px'
        : textarea.scrollHeight + 'px';

    if (
      props.withScroll &&
      props.maxHeight &&
      +textarea.scrollHeight > +props.maxHeight
    ) {
      textarea.style.overflow = 'auto';
    }
    if (textareaBox) {
      textareaBox.style.height = textarea.style.height;
    }
  }
};

onMounted(() => {
  if (inputValue.value) {
    resize();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `textareaBox${uuid.value}`,
    class: _normalizeClass([_ctx.styleType, "textareaBox"]),
    style: _normalizeStyle([cssProps.value, heightConst.value])
  }, [
    _withDirectives(_createElementVNode("textarea", _mergeProps({
      id: `textarea${uuid.value}`,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      disabled: _ctx.disabled,
      rows: 1,
      required: "",
      onKeyup: resize
    }, _toHandlers(listeners.value, true)), "\n    ", 16, _hoisted_2), [
      [_vModelText, inputValue.value]
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1),
    (isError.value || errorMessage.value?.length || _ctx.error?.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(errorMessage.value || _ctx.error), 1))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}
}

})